const FIELDS = [
  {
    title: "金属加工",
    icon: "ri-hammer-line",
    desc: "切削・研磨・プレス・熱処理などにおける寸法ばらつき、面荒れ、変形、割れなどの原因分析。",
    img: "/images/field-metal.jpg",
  },
  {
    title: "樹脂成形",
    icon: "ri-drop-line",
    desc: "射出成形・押出成形などにおける反り、ヒケ、ウェルド、寸法不良、外観不良などの原因究明と条件検討。",
    img: "/images/field-resin.jpg",
  },
  {
    title: "ガラス加工",
    icon: "ri-water-flash-line",
    desc: "研磨・切断・熱衝撃などにおける割れ、欠け、変形、応力残留、光学特性変化などの原因分析。",
    img: "/images/field-glass.jpg",
  },
  {
    title: "蒸着・コーティング",
    icon: "ri-contrast-drop-line",
    desc: "膜厚ばらつき、密着不良、剥離、色ムラ、硬化ばらつきなどについて、工程条件と現象の関係を整理します。",
    img: "/images/field-coating.jpg",
  },
  {
    title: "組立・検査工程",
    icon: "ri-focus-3-line",
    desc: "組立ばらつき、作業手順、治具、検査基準、工程間のズレなど、人・設備・工程を横断して原因を整理します。",
    img: "/images/field-assembly.jpg",
  },
];

export default function Fields() {
  return (
    <section id="fields" className="w-full py-24 md:py-32 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-primary-500" />
            <span className="text-[11px] tracking-[0.35em] text-primary-500 uppercase">Fields</span>
          </div>
          <h4 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-snug mb-6">
            <a href="#fields" className="cursor-pointer">対応分野</a>
          </h4>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            素材・加工・成形・表面処理・組立・検査まで、
            製造工程を横断して対応します。
            特定の業界に限定せず、現象と工程から問題を整理します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {FIELDS.map((f, i) => (
            <article
              key={f.title}
              className={`group relative bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors ${
                i === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className={`relative w-full ${i === 0 ? "h-64 md:h-72" : "h-52"} overflow-hidden bg-background-200`}>
                <img
                  src={f.img}
                  alt={`${f.title} - 原因究明研究所の対応分野`}
                  title={`${f.title} 原因究明 不良解析`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1.5 bg-background-50/95 rounded-md">
                  <div className="w-6 h-6 flex items-center justify-center text-primary-500">
                    <i className={`${f.icon} text-sm`}></i>
                  </div>
                  <span className="text-xs font-medium text-foreground-800">{f.title}</span>
                </div>
              </div>
              <div className="p-6">
                <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}